module.exports = __webpack_public_path__ + "static/media/kc.a834a0a4.jpg";